import _regeneratorRuntime from "@babel/runtime/regenerator";
import { call, put } from 'redux-saga/effects';
import { viewModelStateUpdate } from './actions';
import { CONNECT_VIEWMODEL, DISCONNECT_VIEWMODEL } from '../internal/action-types';
import eventListenerSaga from './event-listener-saga';

var connectViewModelSaga = /*#__PURE__*/_regeneratorRuntime.mark(function connectViewModelSaga(sagaArgs, action) {
  var sagaManager, sagaKey, client, viewModels, query, viewModel, state, _yield$call, data, _yield$call$meta, url, cursor;

  return _regeneratorRuntime.wrap(function connectViewModelSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          sagaManager = sagaArgs.sagaManager, sagaKey = sagaArgs.sagaKey, client = sagaArgs.client, viewModels = sagaArgs.viewModels;
          query = action.query;
          return _context.delegateYield(sagaManager.stop("" + DISCONNECT_VIEWMODEL + sagaKey), "t0", 3);

        case 3:
          viewModel = viewModels.find(function (model) {
            return model.name === query.name;
          });
          state = typeof viewModel.projection.Init === 'function' ? viewModel.projection.Init : null;
          _context.next = 7;
          return put(viewModelStateUpdate(query, state, true));

        case 7:
          _context.next = 9;
          return call([client, client.query], query);

        case 9:
          _yield$call = _context.sent;
          data = _yield$call.data;
          _yield$call$meta = _yield$call.meta;
          url = _yield$call$meta.url;
          cursor = _yield$call$meta.cursor;
          _context.next = 16;
          return put(viewModelStateUpdate(query, data, false));

        case 16:
          state = data;
          return _context.delegateYield(sagaManager.start("" + CONNECT_VIEWMODEL + sagaKey, eventListenerSaga, sagaArgs, {
            url: url,
            cursor: cursor,
            query: query,
            viewModel: viewModel,
            state: state
          }), "t1", 18);

        case 18:
        case "end":
          return _context.stop();
      }
    }
  }, connectViewModelSaga);
});

export default connectViewModelSaga;
//# sourceMappingURL=connect-view-model-saga.js.map